export const skillGroups = [
  {
    title: 'Accessible front end',
    skills: ['WCAG 2.1', 'HTML5', 'CSS3', 'JavaScript', 'React', 'Responsive design'],
  },
  {
    title: 'Platforms and back end',
    skills: ['Drupal', 'Java', 'Node', 'Express', 'PHP', 'REST concepts'],
  },
  {
    title: 'Databases and tools',
    skills: ['MySQL', 'MongoDB', 'Firebase', 'Git and GitHub', 'Linux', 'Adobe suite'],
  },
];
